import React from "react";
import SocialPresence from "../Components/SocialPresence";
import Leads from "../Components/Leads";
import Planning from "../Components/Planning";
import { Analytics, Reporting, BusinessImpact } from "../Components/Insights";
import Presence from "../Components/Presence";
import Guidance from "../Components/Guidance";
import Settings from "../Components/Settings";

export const workspaceRoutes = [
  { path: "/dashboard", title: "Dashboard", permission: "dashboard.view" },
  { path: "/leads", title: "Leads", permission: "leads.view", element: <Leads /> },
  { path: "/planning", title: "Planning", permission: "planning.view", element: <Planning /> },
  { path: "/analytics", title: "Analytics", permission: "analytics.view", element: <Analytics /> },
  { path: "/reviews", title: "Reviews", permission: "reviews.view", element: <Presence reviews /> },
  { path: "/reporting", title: "Reporting", permission: "reports.view", element: <Reporting /> },
  { path: "/inbox", title: "Inbox", permission: "inbox.view" },
  { path: "/business-impact", title: "Business Impact", permission: "impact.view", element: <BusinessImpact /> },
  { path: "/online-presence", title: "Online Presence", permission: "presence.view", element: <Presence /> },
  { path: "/guidance", title: "Guidance & Updates", permission: "guidance.view", element: <Guidance /> },
  { path: "/settings", title: "Settings", permission: "settings.view", element: <Settings /> },
].map((route) => ({ ...route, element: route.element || <SocialPresence /> }));
